<script>
import axios from 'axios';
import snackbarMixin from '@/mixins/snackbar';
import paginationMixin from '@/mixins/pagination';
import downloader from '@/mixins/downloader';

export default {
  name: 'CsvExportDialog',
  components: {
  },
  mixins: [snackbarMixin, paginationMixin, downloader],
  data() {
    return {
      isProcessing: false,
      visible: false,
    };
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    close() {
      this.$emit('cancel');
    },
    onError() {
      this.showErrorMessage('Die Datei konnte nicht importiert werden. Erlaubt sind nur Dateien, die der CSV-Vorlage entsprechen. Zeilenumbrüche sind nicht erlaubt.');
    },
    onExportCsv() {
      this.isProcessing = true;

      axios.get('/employee/csv', {
        responseType: 'blob',
        timeout: 30000,
      })
        .then((response) => {
          this.getDownloadContent(response, 'Mitarbeiter.csv');
          this.showSuccessMessage('Der CSV-Export war erfolgreich.');
          this.close();
        })
        .catch(() => {
          this.showErrorMessage('Beim Herunterladen der Export-Datei ist ein Fehler aufgetreten.');
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        CSV-Export
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>

              <v-flex xs12 md12>
                Durch den CSV-Export wird eine Liste aller Mitarbeiter als CSV-Datei erstellt.
                <br ><br >

                <v-btn @click.native="onExportCsv"
                       color="blue"
                       dark>
                  Export starten
                </v-btn>
              </v-flex>

              <div v-if="isProcessing">
                <v-progress-linear :indeterminate="true"/>
                Exportiere ...
              </div>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
